import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AppConfig } from 'src/app/app.config';
import { context } from 'bookingbug-core-js';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: "root",
})
export class ApiService {
  private core = AppConfig.settings.addressApi;
  private apiServer = 'https://api.bookinglab.co.uk';
  // private apiServer = 'https://staging.bookinglab.co.uk';
  // private apiServer = 'http://localhost:4201';
  private token = '6c8b6f1345457b5d798757b0bc0037feedec70a44d70d131cb675abf29c41999';

  constructor(private http: HttpClient) { }

  async get(postcode) {
    const key = this.core.key
    return await this.http.get(
      `https://api.os.uk/search/places/v1/postcode?postcode=${postcode}&key=${key}&dataset=DPA,LPI`
    ).toPromise();
  }

  async getWeekOfBookings(address, company, slot_datetime, weeklyLimit) {
    const headers = { 'Content-Type': 'application/json', "X-BL-TOKEN": `${this.token}` };
    const body = {
      "host": `${context.apiUrl}`,
      "company_id": `${company.id}`,
      "limit": `${company.extra.booking_limit_days}`,
      "address": `${address.substring(0, 50)}`, // Address in jrni is capped to 50 characters
      "current_date": slot_datetime,
      "weeklyLimit": weeklyLimit
    }

    return await this.http.post(`${this.apiServer}/bookingLimit`, body, { headers }).toPromise();
  }


  async checkEmailNumber(email, mobile, company) {
    const parent = await company.$get('parent');
    const headers = { 'Content-Type': 'application/json', "X-BL-TOKEN": `${this.token}` };
    const body = {
      "host": `${context.apiUrl}`,
      "company_id": `${company.id}`,
      "parent_id": `${parent.id}`,
      "email": email ? email : mobile,
      "searchType": "elastic"
    }

    return await this.http.post(`${this.apiServer}/findElasticClientSecure`, body, { headers }).toPromise();
  }

  async getBookingsForUser(company, parent, email) {
    const headers = { 'Content-Type': 'application/json', 'X-BL-TOKEN': `${this.token}` };
    const body = {
      "host": `${context.apiUrl}`,
      "company_id": `${company.id}`,
      "parent_id": `${parent.id}`,
      "email": `${email}`,
    }

    return await this.http.post(`${this.apiServer}/findElasticClientSecure`, body, { headers }).toPromise();
  }

  async checkForDoubleBooking(company, slot, email = null, mobile = null) {
    const parent = await company.$get('parent');
    const headers = { 'Content-Type': 'application/json', "X-BL-TOKEN": `${this.token}` };
    const body = {
      "host": `${context.apiUrl}`,
      "company_id": `${company.id}`,
      "parent_id": `${parent.id}`,
      "current_date": slot,
    }

    if (email) {
      body["email"] = email;
    } else {
      body["mobile"] = mobile;
    }

    // return this.http.post('https://staging.bookinglab.co.uk/unavailableTimes', body, { headers }).toPromise();
    return this.http.post(`${this.apiServer}/unavailableTimes`, body, { headers }).toPromise();
  }

  async checkSlotAvailability(company, slot) {
    const headers = { 'Content-Type': 'application/json', "X-BL-TOKEN": `${this.token}` };
    const body = {
      "host": `${context.apiUrl}`,
      "company_id": `${company.id}`,
      "slot": slot,
    }

    return this.http.post(`${this.apiServer}/slotAvailability`, body, { headers }).toPromise();
  }

  async getVehicleDetails(vehiclereg) {
    const headers = { 'Content-Type': 'application/json', 'X-BL-TOKEN': `${this.token}` };
    const body = {
      "host": `${context.apiUrl}`
    }

    return await this.http.post(`${this.apiServer}/dvlaVehicleEnquiry/${vehiclereg}`, body, { headers }).toPromise();
  }

  async getAddressException() {
    const headers = { 'Content-Type': 'application/json', 'X-BL-TOKEN': `${this.token}` };
    const body = {
      "host": `${context.apiUrl}`
    }

    return await this.http.post(`${this.apiServer}/addressException`, body, { headers }).toPromise();
  }



  async getFormSchema(formId: string, companyId: any, companyName: string) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'clienttoken': environment.clientToken
      };
      const data = {
        company: companyId,
        client: `${companyName}`,
        form_name: `${formId}`
      };
      return await this.http.post(`${environment.apiServer}/form/schema`, data, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }


  async getProviderFormDataForDependent(companyId: number, childId: string) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'clienttoken': environment.clientToken
      };
      return await this.http.get(`${environment.apiServer}/company/${companyId}/dependent/${childId}/show`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async saveProviderFormDataForDependent(companyId: number, childId: string, formData: any) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'clienttoken': environment.clientToken
      };
      return await this.http.post(`${environment.apiServer}/company/${companyId}/dependent/${childId}`, formData, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }



  async moveBooking(booking: any, member: any, slot: any, duration) {

    const authToken = localStorage.getItem('auth_token');
    const memberId = member.id;
    const companyId = booking.company_id
    const bookingid = booking.id;
    const datetime = new Date(slot);

    try {
      const headers = {
        'Content-Type': 'application/json',
        'X-BL-TOKEN': `${this.token}`,
        'authtoken': authToken,
        'x-member-id': `${memberId}`,
        'x-company-id': `${companyId}`,
        'x-app-id': AppConfig.settings.core.app_id,
        'clienttoken': environment.clientToken
      };

      const body = {
        date: datetime.toISOString().split('T')[0],
        time: datetime.getMinutes() + (datetime.getHours() * 60),
        "duration": duration //booking.duration / 60 / 60,
      };

      return await this.http.put(`${environment.apiServer}/company/${companyId}/member/${memberId}/bookings/${bookingid}/move`, body, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async cancelBookings(booking, member) {

    const authToken = localStorage.getItem('auth_token');
    const memberId = member.id;
    const companyId = booking.company_id
    const bookingId = booking.id;

    const headers = {
      'Content-Type': 'application/json',
      'X-BL-TOKEN': `${this.token}`,
      'authtoken': authToken,
      'x-member-id': `${memberId}`,
      'x-company-id': `${companyId}`,
      'clienttoken': environment.clientToken
    };

    const body = {
      "host": `${context.apiUrl}`,
      "company_id": `${companyId}`,
      "booking_id": `${bookingId}`
    }
    return this.http.post(`${this.apiServer}/cancelMultiBookings`, body, { headers }).toPromise();
  }

  //   async moveBooking(booking, member, slot, person_id) {
  //     const datetime = new Date(slot);
  //  ///company/{company}/member/{member}/bookings/{booking}/move
  //     const headers = { 'Content-Type': 'application/json', "X-BL-TOKEN": `${this.token}` };
  //     const apiServer = AppConfig.settings.apiServer;

  //     const apiUrl = `${this.apiServer}/rescheduleBooking`;
  //     return await this.http.post(apiUrl, {
  //       host:apiServer.api_url.split('ps://')[1].split(".")[0],
  //       company_id:booking.company_id,
  //       date: datetime.toISOString().split('T')[0],
  //       time: datetime.getMinutes() + (datetime.getHours() * 60),
  //       email: true,
  //       email_owner: true,
  //       person_id:person_id,
  //       bookingId:booking.id,
  //       duration:booking.duration,
  //       questions:booking.questions,
  //     }, { headers }).toPromise();
  //   }


  async getBookings(companyId: number, memberId: number) {

    const authToken = localStorage.getItem('auth_token');

    try {
      // const headers = {
      //   'Content-Type': 'application/json',
      //   'x-member-id': `${memberId}`,
      //   'authtoken': authToken,
      //   'x-company-id': `${companyId}`,
      //   'clienttoken': environment.clientToken

      // };
      const headers = {
        'Content-Type': 'application/json',
        'X-BL-TOKEN': `${this.token}`,
        'authtoken': authToken,
        'x-member-id': `${memberId}`,
        'x-company-id': `${companyId}`,
        'clienttoken': environment.clientToken,
        'x-app-id': AppConfig.settings.core.app_id
      };

      return await this.http.get(`${environment.apiServer}/company/${companyId}/member/${memberId}/bookings`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }
  async getChildren(companyId: number, memberId: number) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'clienttoken': environment.clientToken
      };
      return await this.http.get(`${environment.apiServer}/company/${companyId}/client/${memberId}/dependents`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async passwordReset(email: string, companyId: any) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'clienttoken': environment.clientToken
      };

      const bodyData = {
        "email": email
      }
      return await this.http.post(`${environment.apiServer}/company/${companyId}/forgot-password`, bodyData, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async saveHwrcAddressForm(client_id: string, companyId: any, body: any) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'clienttoken': environment.clientToken
      };

      const bodyData = {
        "body": JSON.stringify(body)
      }
      return await this.http.post(`${environment.apiServer}/company/${companyId}/client/${client_id}/hwrc/address`, bodyData, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async saveHwrcVehicleForm(client_id: string, companyId: any, body: any) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'clienttoken': environment.clientToken
      };

      const bodyData = {
        "body": JSON.stringify(body)
      }
      return await this.http.post(`${environment.apiServer}/company/${companyId}/client/${client_id}/hwrc/vehicle`, bodyData, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getHwrcVehicleForm(client_id: string, companyId: any, no: number) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'clienttoken': environment.clientToken
      };

      return await this.http.get(`${environment.apiServer}/company/${companyId}/client/${client_id}/hwrc/vehicle?no=${no}`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getHwrcAddressForm(client_id: string, companyId: any, no: number) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'clienttoken': environment.clientToken
      };

      return await this.http.get(`${environment.apiServer}/company/${companyId}/client/${client_id}/hwrc/address?no=${no}`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getConfig() {
    // console.log(`Loading '${environment.companyName}' config.`);
    const headers = {
      'Content-Type': 'application/json',
      'clienttoken': environment.clientToken
    };
    const companyName = AppConfig.settings.apiServer.api_url.split("://")[1].split(".")[0]
    const body = {
      "client": `${companyName}`,
      "company": `${AppConfig.settings.core.company_id}`
    }

    return await this.http.post(`${environment.apiServer}/config`, body, { headers }).toPromise();
  }

  async checkEmailAndName(email, company) {
    const headers = {
      'Content-Type': 'application/json',
      'clienttoken': environment.clientToken
    };

    return await this.http.get(`${environment.apiServer}/company/${company}/client/email/${email}`, { headers }).toPromise();
  }

  async updateBooking(booking_id, company_id, body) {
    const headers = {
      'Content-Type': 'application/json',
      'clienttoken': environment.clientToken
    };

    return await this.http.put(`${environment.apiServer}/company/${company_id}/booking/${booking_id}`, body, { headers }).toPromise();
  }

  async getBooking(booking_id, company_id) {
    const headers = {
      'Content-Type': 'application/json',
      'clienttoken': environment.clientToken
    };

    return await this.http.get(`${environment.apiServer}/company/${company_id}/booking/${booking_id}`, { headers }).toPromise();
  }


  async questions(detailgroupid: any, companyid: any) {

    // const authToken = this.dataStore.authToken;
    // const memberid = this.dataStore.member.id;

    try {
      const headers = {
        'Content-Type': 'application/json',
        'clienttoken': environment.clientToken
      };

      return await this.http.get(`${environment.apiServer}/company/${companyid}/questions/${detailgroupid}`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async generateSSOToken(companyId: any, first_name: any, last_name: any, email: any) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'clienttoken': `${environment.clientToken}`
      };

      const bodyData = {
        first_name: `${first_name}`,
        last_name: `${last_name}`,
        email: `${email}`
      };

      return await this.http.post(`${environment.apiServer}/company/${companyId}/sso`, bodyData, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async ssoLogin(companyId: any, token: any) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'clienttoken': `${environment.clientToken}`,
        'x-app-id': AppConfig.settings.core.app_id
      };

      const bodyData = {
        token: `${token}`
      };

      return await this.http.post(`${environment.apiServer}/company/${companyId}/sso/login`, bodyData, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async passwordResetTokenBased(email: string, companyId: any, path: string) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'clienttoken': environment.clientToken
      };

      const bodyData = {
        "email": email,
        "token_based_reset": true,
        "path": `${path}`
      }
      return await this.http.post(`${environment.apiServer}/company/${companyId}/forgot-password`, bodyData, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  sendStatusUpdate(companyId: number, booking: any, config: any) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'clienttoken': environment.clientToken
      };
      booking._data = JSON.parse(JSON.stringify(booking))
      booking.config = config
      booking.pushType = "new"
      booking.clientName = config.host.split("//")[1].split(".")[0]
      booking.companyId = companyId

      return this.http.post(`${environment.apiServer}/notifications/add-booking`, booking, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }
}